export enum TakesCareStepNames {
  PERSONAL_INFO = 'INFO-PESSOAIS',
  PERSONAL_DATA = 'DADOS-PESSOAIS',
  ADDRESS = 'ENDERECO',
  RESUME = 'RESUMO',
}

export enum BagProtectionStepNames {
  INTRODUCTION = 'INTRODUCAO',
  PERSONAL_INFO = 'INFO-PESSOAIS',
  CONTACT = 'CONTATO',
  ADDRESS = 'ENDERECO',
  RESUME = 'RESUMO',
}

export enum IncomeProtectionStepNames {
  INTRODUCTION = 'INTRODUCAO',
  PERSONAL_INFO = 'INFO-PESSOAIS',
  CONTACT = 'CONTATO',
  ADDRESS = 'ENDERECO',
  RESUME = 'RESUMO',
}

export enum AutoStepNames {
  PLATE = 'PLACA',
  VEHICLE = 'VEICULO',
  INSURANCE_EXPIRY = 'EXPIRACAO-SEGURO',
  QUIZ_USAGE = 'QUIZ-USO',
  QUIZ_STORAGE = 'QUIZ-LOCAL-GUARDA',
  ADDRESS = 'ENDERECO',
  DOCUMENT = 'CPF',
  SERVICES = 'SERVICOS',
  PERSONAL_INFO = 'INFO-PESSOAIS',
  PHONE = 'CONTATO-CELULAR',
  LOADING = 'BUSCANDO-COTACOES',
  QUOTE_RESULT = 'RESULTADO-COTACOES',
  QUOTE_DETAILS = 'DETALHES-COTACAO',
  QUOTE_EMPTY = 'SEM-COTACOES',
}

export enum CheckoutStepNames {
  PAYMENT_METHODS = 'METODOS-PAG',
  INSTALLMENTS = 'PARCELAS',
  CREDIT_CARD = 'CARTAO-CREDITO',
  ACCOUNT_DEBIT = 'DEBITO-CONTA',
  BANK_SLIP = 'BOLETO',
  LICENSE = 'HABILITACAO',
  VEHICLE_INFO = 'INFOS-VEICULO',
  EMAIL = 'EMAIL',
  SUCCESS = 'CONTRATO-SUCESSO',
  ERROR = 'CONTRATO-ERRO',
}

export enum ContractSellerStepNames {
  DOCUMENT = 'CPF-VENDEDOR',
  INFO = 'INFOS-VENDEDOR',
}
